import React from "react";
import { formatUSD } from "../lib/format";
import { ChartLineUp, Database, Brain, Lightning } from "@phosphor-icons/react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/2edb5505-d997-4b65-9295-9b1d877224b9/images/78e6445086895a1ecb004714c93fe39580b6c61e1d31bceaac171cdb5f418dc4.png";

function Stat({ label, value, sub, icon: Icon, accent, testid }) {
  return (
    <div
      data-testid={testid}
      className="relative border border-white/10 p-5 bg-zinc-950/60 hover:border-white/25 transition-colors"
    >
      <div className="flex items-start justify-between">
        <div className="text-[10px] uppercase tracking-[0.22em] font-mono text-zinc-500">
          {label}
        </div>
        <Icon size={18} weight="duotone" className={accent || "text-zinc-400"} />
      </div>
      <div className="mt-3 font-mono text-3xl font-medium tabular-nums tracking-tight">
        {value}
      </div>
      {sub && (
        <div className="mt-1 text-xs text-zinc-500 font-body">{sub}</div>
      )}
    </div>
  );
}

export default function StatsHero({ stats }) {
  return (
    <section
      data-testid="stats-hero"
      className="relative border-b border-white/10 overflow-hidden grain"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          WebkitMaskImage:
            "linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.15) 60%, rgba(0,0,0,0) 100%)",
          maskImage:
            "linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.15) 60%, rgba(0,0,0,0) 100%)",
        }}
      />
      <div className="relative mx-auto max-w-[1600px] px-6 py-12">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="text-[10px] uppercase tracking-[0.32em] font-mono text-edge mb-3">
              ◢ AI Forecast Terminal · v1.0
            </div>
            <h1 className="font-display font-semibold text-4xl sm:text-5xl tracking-tight leading-[1.05]">
              Live Polymarket odds.
              <br />
              <span className="text-zinc-400">Calibrated AI</span>{" "}
              <span className="text-edge">forecasts.</span>
            </h1>
            <p className="mt-5 max-w-xl text-sm sm:text-base text-zinc-400 font-body leading-relaxed">
              MFSMAI Oracle pulls live prediction-market data from Polymarket
              and pairs every market with calibrated AI forecasts. Spot
              mispricing, track your edge, trade smarter — all gated by your
              MFSMAI holdings on BSC.
            </p>
          </div>

          <div className="col-span-12 lg:col-span-5 grid grid-cols-2 gap-3">
            <Stat
              testid="stat-markets"
              label="Active Markets"
              value={stats ? stats.activeMarkets : "—"}
              sub="Top-volume liquid"
              icon={Database}
              accent="text-zinc-300"
            />
            <Stat
              testid="stat-volume"
              label="Volume (Top 100)"
              value={stats ? formatUSD(stats.totalVolume) : "—"}
              sub="All-time"
              icon={ChartLineUp}
              accent="text-profit"
            />
            <Stat
              testid="stat-liquidity"
              label="Liquidity"
              value={stats ? formatUSD(stats.totalLiquidity) : "—"}
              sub="Order books"
              icon={Lightning}
              accent="text-yellow-400"
            />
            <Stat
              testid="stat-ai"
              label="AI Forecasts"
              value={stats ? stats.aiPredictions : "—"}
              sub="Generated"
              icon={Brain}
              accent="text-edge"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
